import React from "react";
import { NavLink } from "react-router-dom";

interface Props {
  icon: JSX.Element;
  label: string;
  isCollapsed: boolean;
  to: string;
}

const Item: React.FC<Props> = ({ icon, label, isCollapsed, to, ...props }) => (
  <NavLink to={to}>
    {({ isActive }) => (
      <div
        {...props}
        className={`navlink relative left-0 top-0 w-full h-16 group ${
          isActive ? "font-extrabold cursor-default active" : "cursor-pointer"
        }`}
      >
        <div
          className={`absolute w-full h-full left-0 top-0 transition duration-100 ease-in ${
            isActive
              ? "bg-rich-blue-darkest opacity-25"
              : "bg-transparent opacity-10 group-hover:bg-rich-blue-darkest"
          }`}
        />
        <div
          className={`absolute bg-vibrant-yellow h-full${
            isActive ? " w-1" : " w-0"
          }`}
        />
        <div
          className={`absolute top-0 left-0 flex w-full h-full px-6 py-5 ${
            !isCollapsed ? "" : "justify-center"
          }`}
        >
          <div className="flex items-center justify-center w-5 max-h-full">
            {icon}
          </div>
          {!isCollapsed && (
            <div className="ml-3 whitespace-no-wrap transform translate-y-px">
              {label}
            </div>
          )}
        </div>
      </div>
    )}
  </NavLink>
);

export default Item;
